import { CommonModule, Location } from '@angular/common'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from '@auth/services/auth.service'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

/**
 * Handles a redirected user from a billing operation, usually before upgrading a workspace via stripe
 */
@Component({
  selector: 'ngx-billing-redirect',
  templateUrl: './billing-redirect.component.html',
  styleUrls: ['./billing-redirect.component.scss'],
  imports: [CommonModule]
})
export class BillingRedirectComponent implements OnInit, OnDestroy {
  /** Subject that stops all hot observables */
  private _destroy$ = new Subject()
  /** On destroy implementation */
  ngOnDestroy() {
    this._destroy$.next(null)
    this._destroy$.complete()
  }
  /**
   * Creates the component and injects it's dependencies
   * @param auth AuthService
   * @param location window location object
   */
  constructor(private auth: AuthService, private location: Location) {}

  /**
   * OnInit implementation
   * redirects the user to stripe
   */
  ngOnInit(): void {
    this.auth
      .createCustomerPortal('')
      .pipe(takeUntil(this._destroy$))
      .subscribe((result: any) => {
        window.open(result.url, '_blank')
        this.location.back()
      })
  }
}
